import { Typography } from "@material-ui/core";
import React from "react";

const Header = () => {
  return (
    <header>
      <Typography
        variant="h1"
        className="text-3xl font-extrabold"
        style={{ color: "#ff3c2e" }}
      >
        TAKESHAPE<span style={{ color: "black" }}>ADVENTURES</span>
      </Typography>
      <Typography
        variant="h2"
        className="mt-4 text-2xl leading-9 font-bold text-gray-900"
      >
        Sign in to your account
      </Typography>
      <Typography variant="body1" style={{ color: "#25c8e8" }}>
        Or{" "}
        <a
          href="#"
          className="font-medium text-red-600 hover:text-red-500 focus:outline-none focus:underline transition ease-in-out duration-150"
        >
          become a member now
        </a>
      </Typography>
    </header>
  );
};
export default Header;
